console.log('shipping cart');

function getTotal() {
  return parseFloat(document.querySelector('.totals__subtotal-value').innerText.replace('€', '').replace('EUR', '').replace('.', '').replace(',', '.'));
}

function checkShippingInfo() {
  const shippingInfo = document.querySelector('.shipping-info');
  const shippingText = document.querySelector('.shipping-info .shipping-text');
  
  const percent = document.querySelector('.shipping-info .percent-bar .percent');
  const total = getTotal();

  const freeAmount = 50;

  if (total > 0 && total < freeAmount) {
    percent.style.width = Math.round(total * 100 / freeAmount) + '%';
    const price = ('' + Math.round((freeAmount - total) * 100) / 100).replace('.', ',');
    shippingText.innerText = 'Noch ' + price +' € bis zum kostenlosen Versand!';
    
    // shippingInfo.style.display = 'block';
  } else {
    // shippingInfo.style.display = 'none';
  }
}

window.onload = () => {
  checkShippingInfo();

  window.onclick = () => {
    setTimeout(() => {
      checkShippingInfo();
    }, 1000);
  }

  //console.log(total, freeAmount);
}